import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CommonAccessTokenService {
  constructor(private location: Location) {}

  isAccessTokenPage(): boolean {
    return this.location.path().includes('/accessToken/');
  }

  getAccessTokenFromUrl(): string | null {
    const path = this.location.path();
    const accessTokenIndex = path.indexOf('/accessToken/');
    if (accessTokenIndex !== -1) {
      const token = path.substring(accessTokenIndex + '/accessToken/'.length);
      return token ? decodeURIComponent(token) : null;
    }
    return null;
  }
}
